import { genId } from '@ocodelib/ex-util';
import type { IProjectLoader, ProjectFile, ProjectLoadResult } from '@repo/project-interface';
import { DEFAULT_FILES } from './sample-files';

/**
 * 샘플용 새프로젝트 로더
 */
export class NewProjectLoader implements IProjectLoader<ProjectFile[]> {
  async load(): Promise<ProjectLoadResult<ProjectFile[]>> {
    const projectFiles = [] as ProjectFile[];
    DEFAULT_FILES.forEach((file) => {
      projectFiles.push({
        fileKey: genId('file_', (id) => projectFiles.some((it) => it.fileKey === id)),
        name: file.name,
        path: file.name,
        content: file.code,
        language: file.language,
      });
    });

    return {
      breed: 'js',
      project: undefined,
      projectName: '새 프로젝트',
      data: projectFiles,
    };
  }
}
